import formInputsTypes from '../simulatorConstant';

const forfaitsData = [];

const forfaitsPortail = {
	id: 'ForfaitsSM',
	type: formInputsTypes?.CHECKBOX_INPUT,
	label: 'Forfaits',
	name: 'ForfaitsSM',
	className: 'col-12',
	classGroup: 'simulator-check',
	options: forfaitsData,
};

export default forfaitsPortail;
